import React, { useMemo } from "react";
import { Modal, Space, Card, Row, Col, Typography, Statistic, Divider, Tag, Empty } from "antd";
import { SolutionOutlined, UserOutlined, TeamOutlined, DollarOutlined, CalendarOutlined, CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useDraggableModal } from "../Balancete/utils/modalDraggable";

const { Title, Text, Paragraph } = Typography;

export default function ModalFolha({
    visible,
    onClose,
    title,
    zIndex,
    onFocus,
}) {
    const draggableProps = useDraggableModal(zIndex, onFocus, {
        visible,
        modalKey: 'folha',
        initialWidth: 1000,
        initialHeight: 'auto',
        overflow: 'hidden'
    });

    const company = useMemo(() => {
        try {
            return JSON.parse(sessionStorage.getItem("COMPANY")) || {};
        } catch {
            return {};
        }
    }, []);

    const hasFolha = company?.folha === true;
    const hasProlabore = company?.prolabore === true;
    const numFuncionarios = company?.numeroFuncionarios || 0;

    return (
        <Modal
            title={title || (
                <Space>
                    <SolutionOutlined style={{ color: '#4f46e5' }} />
                    <span>Informações da Folha de Pagamento</span>
                </Space>
            )}
            open={visible}
            onCancel={onClose}
            width={700}
            footer={null}
            {...draggableProps}
            styles={{
                body: {
                    maxHeight: "80vh",
                    padding: '24px',
                    overflowY: "auto"
                }
            }}
        >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                {/* Header Info */}
                <Card size="small" className="premium-card" style={{ background: '#f8fafc' }}>
                    <Row gutter={16} align="middle">
                        <Col span={16}>
                            <Title level={4} style={{ margin: 0 }}>{company?.nome || "Empresa"}</Title>
                            <Text type="secondary">{company?.cnpj || "CNPJ não informado"}</Text>
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Tag color={hasFolha ? "green" : "red"} style={{ borderRadius: '4px' }}>
                                {hasFolha ? "FOLHA ATIVA" : "SEM FOLHA"}
                            </Tag>
                        </Col>
                    </Row>
                </Card>

                {/* Statistics */}
                <Row gutter={16}>
                    <Col span={8}>
                        <Card className="premium-card">
                            <Statistic 
                                title="Funcionários" 
                                value={numFuncionarios} 
                                prefix={<TeamOutlined style={{ color: '#4f46e5' }} />} 
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card className="premium-card">
                            <Statistic 
                                title="Pró-labore" 
                                value={hasProlabore ? "Ativo" : "Inativo"} 
                                valueStyle={{ color: hasProlabore ? '#059669' : '#e11d48' }}
                                prefix={<UserOutlined />} 
                            />
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card className="premium-card">
                            <Statistic 
                                title="Competência" 
                                value="Atual" 
                                prefix={<CalendarOutlined style={{ color: '#d97706' }} />} 
                            />
                        </Card>
                    </Col>
                </Row>

                <Divider style={{ margin: '12px 0' }} />

                {/* Details Section */}
                <Title level={5}><InfoCircleOutlined style={{ marginRight: 8 }} /> Detalhes da Operação</Title>
                
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Card size="small" className="premium-card">
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Text strong><DollarOutlined style={{ marginRight: 8 }} /> Envio de Eventos (eSocial)</Text>
                                    <Tag color="blue" icon={<CheckCircleOutlined />}>Sincronizado</Tag>
                                </div>
                                <Paragraph style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0 24px' }}>
                                    Os dados de movimentação de pessoal e pró-labore são integrados automaticamente com a contabilidade para fins de fechamento mensal.
                                </Paragraph>
                            </Space>
                        </Card>
                    </Col>
                    
                    <Col span={24}>
                        <Card size="small" className="premium-card">
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Text strong><SolutionOutlined style={{ marginRight: 8 }} /> Retenções e Encargos (DCTFWeb)</Text>
                                    <Tag color="cyan">Em Aberto</Tag>
                                </div>
                                <Paragraph style={{ fontSize: '13px', color: '#64748b', margin: '4px 0 0 24px' }}>
                                    As guias de INSS e FGTS são geradas após o fechamento da folha no portal de RH correspondente.
                                </Paragraph>
                            </Space>
                        </Card>
                    </Col>
                </Row>

                {!hasFolha && !hasProlabore && (
                    <Empty 
                        image={Empty.PRESENTED_IMAGE_SIMPLE} 
                        description="Nenhuma configuração de folha detectada para esta empresa." 
                    />
                )}

                <div style={{ marginTop: 24, padding: '16px', background: '#eff6ff', borderRadius: '12px', border: '1px solid #bfdbfe' }}>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                        <InfoCircleOutlined style={{ marginRight: 6 }} />
                        Estas informações são baseadas no cadastro atual da empresa e nos eventos enviados recentemente. Para alterações, entre em contato com o setor de RH.
                    </Text>
                </div>
            </Space>
        </Modal>
    );
}
